/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import { SymbolRoofingIcon } from "./icons/SymbolRoofingIcon.tsx";
import { SymbolConstructionIcon } from "./icons/SymbolConstructionIcon.tsx";
import { SymbolHandymanIcon } from "./icons/SymbolHandymanIcon.tsx";
import { SymbolHardwareIcon } from "./icons/SymbolHardwareIcon.tsx";
import { SymbolBuildIcon } from "./icons/SymbolBuildIcon.tsx";
import { SymbolHomeRepairServiceIcon } from "./icons/SymbolHomeRepairServiceIcon.tsx";
import { SymbolPlumbingIcon } from "./icons/SymbolPlumbingIcon.tsx";
import { SymbolCarpenterIcon } from "./icons/SymbolCarpenterIcon.tsx";
import { SymbolElectricalServicesIcon } from "./icons/SymbolElectricalServicesIcon.tsx";
import { SymbolArchitectureIcon } from "./icons/SymbolArchitectureIcon.tsx";
import { SymbolEngineeringIcon } from "./icons/SymbolEngineeringIcon.tsx";
import { SymbolFoundationIcon } from "./icons/SymbolFoundationIcon.tsx";
import { SymbolFenceIcon } from "./icons/SymbolFenceIcon.tsx";
import { SymbolDeckIcon } from "./icons/SymbolDeckIcon.tsx";
import { SymbolFormatPaintIcon } from "./icons/SymbolFormatPaintIcon.tsx";
import { SymbolImagesearchRollerIcon } from "./icons/SymbolImagesearchRollerIcon.tsx";
import { SymbolDesignServicesIcon } from "./icons/SymbolDesignServicesIcon.tsx";
import { SymbolStraightenIcon } from "./icons/SymbolStraightenIcon.tsx";
import { SymbolSquareFootIcon } from "./icons/SymbolSquareFootIcon.tsx";
import { SymbolHvacIcon } from "./icons/SymbolHvacIcon.tsx";
import { SymbolSolarPowerIcon } from "./icons/SymbolSolarPowerIcon.tsx";
import { SymbolWaterDamageIcon } from "./icons/SymbolWaterDamageIcon.tsx";
import { SymbolPestControlIcon } from "./icons/SymbolPestControlIcon.tsx";
import { SymbolCleaningServicesIcon } from "./icons/SymbolCleaningServicesIcon.tsx";
import { SymbolPrecisionManufacturingIcon } from "./icons/SymbolPrecisionManufacturingIcon.tsx";
import { SymbolToolsPowerDrillIcon } from "./icons/SymbolToolsPowerDrillIcon.tsx";
import { SymbolToolsLadderIcon } from "./icons/SymbolToolsLadderIcon.tsx";
import { SymbolToolsLevelIcon } from "./icons/SymbolToolsLevelIcon.tsx";
import { SymbolToolsPliersWireStripperIcon } from "./icons/SymbolToolsPliersWireStripperIcon.tsx";
import { SymbolToolsFlatHeadIcon } from "./icons/SymbolToolsFlatHeadIcon.tsx";
import { SymbolAgricultureIcon } from "./icons/SymbolAgricultureIcon.tsx";
import { SymbolForkliftIcon } from "./icons/SymbolForkliftIcon.tsx";
import { SymbolFrontLoaderIcon } from "./icons/SymbolFrontLoaderIcon.tsx";
import { SymbolFireExtinguisherIcon } from "./icons/SymbolFireExtinguisherIcon.tsx";
import { SymbolHomeIcon } from "./icons/SymbolHomeIcon.tsx";
import { SymbolCottageIcon } from "./icons/SymbolCottageIcon.tsx";
import { SymbolVillaIcon } from "./icons/SymbolVillaIcon.tsx";
import { SymbolHouseIcon } from "./icons/SymbolHouseIcon.tsx";
import { SymbolCabinIcon } from "./icons/SymbolCabinIcon.tsx";
import { SymbolChaletIcon } from "./icons/SymbolChaletIcon.tsx";
import { SymbolBungalowIcon } from "./icons/SymbolBungalowIcon.tsx";
import { SymbolGiteIcon } from "./icons/SymbolGiteIcon.tsx";
import { SymbolOtherHousesIcon } from "./icons/SymbolOtherHousesIcon.tsx";
import { SymbolHolidayVillageIcon } from "./icons/SymbolHolidayVillageIcon.tsx";
import { SymbolApartmentIcon } from "./icons/SymbolApartmentIcon.tsx";
import { SymbolDomainIcon } from "./icons/SymbolDomainIcon.tsx";
import { SymbolCorporateFareIcon } from "./icons/SymbolCorporateFareIcon.tsx";
import { SymbolLocationCityIcon } from "./icons/SymbolLocationCityIcon.tsx";
import { SymbolWarehouseIcon } from "./icons/SymbolWarehouseIcon.tsx";
import { SymbolGarageIcon } from "./icons/SymbolGarageIcon.tsx";
import { SymbolGarageHomeIcon } from "./icons/SymbolGarageHomeIcon.tsx";
import { SymbolFactoryIcon } from "./icons/SymbolFactoryIcon.tsx";
import { SymbolStoreIcon } from "./icons/SymbolStoreIcon.tsx";
import { SymbolStorefrontIcon } from "./icons/SymbolStorefrontIcon.tsx";
import { SymbolCastleIcon } from "./icons/SymbolCastleIcon.tsx";
import { SymbolChurchIcon } from "./icons/SymbolChurchIcon.tsx";
import { SymbolSchoolIcon } from "./icons/SymbolSchoolIcon.tsx";
import { SymbolStadiumIcon } from "./icons/SymbolStadiumIcon.tsx";
import { SymbolAccountBalanceIcon } from "./icons/SymbolAccountBalanceIcon.tsx";
import { SymbolHotelIcon } from "./icons/SymbolHotelIcon.tsx";
import { SymbolRealEstateAgentIcon } from "./icons/SymbolRealEstateAgentIcon.tsx";
import { SymbolHomeWorkIcon } from "./icons/SymbolHomeWorkIcon.tsx";
import { SymbolYardIcon } from "./icons/SymbolYardIcon.tsx";
import { SymbolLocalHospitalIcon } from "./icons/SymbolLocalHospitalIcon.tsx";
import { SymbolMuseumIcon } from "./icons/SymbolMuseumIcon.tsx";
import { SymbolFestivalIcon } from "./icons/SymbolFestivalIcon.tsx";
import { SymbolParkIcon } from "./icons/SymbolParkIcon.tsx";
import { SymbolForestIcon } from "./icons/SymbolForestIcon.tsx";
import { SymbolNatureIcon } from "./icons/SymbolNatureIcon.tsx";
import { SymbolEcoIcon } from "./icons/SymbolEcoIcon.tsx";
import { SymbolGrassIcon } from "./icons/SymbolGrassIcon.tsx";
import { SymbolPottedPlantIcon } from "./icons/SymbolPottedPlantIcon.tsx";
import { SymbolLocalFloristIcon } from "./icons/SymbolLocalFloristIcon.tsx";
import { SymbolLandscapeIcon } from "./icons/SymbolLandscapeIcon.tsx";
import { SymbolVolcanoIcon } from "./icons/SymbolVolcanoIcon.tsx";
import { SymbolWaterDropIcon } from "./icons/SymbolWaterDropIcon.tsx";
import { SymbolWaterIcon } from "./icons/SymbolWaterIcon.tsx";
import { SymbolWavesIcon } from "./icons/SymbolWavesIcon.tsx";
import { SymbolTsunamiIcon } from "./icons/SymbolTsunamiIcon.tsx";
import { SymbolFloodIcon } from "./icons/SymbolFloodIcon.tsx";
import { SymbolSunnyIcon } from "./icons/SymbolSunnyIcon.tsx";
import { SymbolPartlyCloudyDayIcon } from "./icons/SymbolPartlyCloudyDayIcon.tsx";
import { SymbolCloudIcon } from "./icons/SymbolCloudIcon.tsx";
import { SymbolRainyIcon } from "./icons/SymbolRainyIcon.tsx";
import { SymbolThunderstormIcon } from "./icons/SymbolThunderstormIcon.tsx";
import { SymbolStormIcon } from "./icons/SymbolStormIcon.tsx";
import { SymbolTornadoIcon } from "./icons/SymbolTornadoIcon.tsx";
import { SymbolFoggyIcon } from "./icons/SymbolFoggyIcon.tsx";
import { SymbolAirIcon } from "./icons/SymbolAirIcon.tsx";
import { SymbolAcUnitIcon } from "./icons/SymbolAcUnitIcon.tsx";
import { SymbolSevereColdIcon } from "./icons/SymbolSevereColdIcon.tsx";
import { SymbolSunnySnowingIcon } from "./icons/SymbolSunnySnowingIcon.tsx";
import { SymbolBedtimeIcon } from "./icons/SymbolBedtimeIcon.tsx";
import { SymbolNightlightIcon } from "./icons/SymbolNightlightIcon.tsx";
import { SymbolWbTwilightIcon } from "./icons/SymbolWbTwilightIcon.tsx";
import { SymbolLocalFireDepartmentIcon } from "./icons/SymbolLocalFireDepartmentIcon.tsx";
import { SymbolWhatshotIcon } from "./icons/SymbolWhatshotIcon.tsx";
import { SymbolPublicIcon } from "./icons/SymbolPublicIcon.tsx";
import { SymbolCompostIcon } from "./icons/SymbolCompostIcon.tsx";
import { SymbolEnergySavingsLeafIcon } from "./icons/SymbolEnergySavingsLeafIcon.tsx";
import { SymbolPetsIcon } from "./icons/SymbolPetsIcon.tsx";
import { SymbolCrueltyFreeIcon } from "./icons/SymbolCrueltyFreeIcon.tsx";
import { SymbolRavenIcon } from "./icons/SymbolRavenIcon.tsx";
import { SymbolEmojiNatureIcon } from "./icons/SymbolEmojiNatureIcon.tsx";
import { SymbolBugReportIcon } from "./icons/SymbolBugReportIcon.tsx";
import { SymbolSoundDetectionDogBarkingIcon } from "./icons/SymbolSoundDetectionDogBarkingIcon.tsx";
import { SymbolSetMealIcon } from "./icons/SymbolSetMealIcon.tsx";
import { SymbolEggIcon } from "./icons/SymbolEggIcon.tsx";
import { SymbolPhishingIcon } from "./icons/SymbolPhishingIcon.tsx";
import { SymbolDirectionsCarIcon } from "./icons/SymbolDirectionsCarIcon.tsx";
import { SymbolElectricCarIcon } from "./icons/SymbolElectricCarIcon.tsx";
import { SymbolLocalShippingIcon } from "./icons/SymbolLocalShippingIcon.tsx";
import { SymbolLocalTaxiIcon } from "./icons/SymbolLocalTaxiIcon.tsx";
import { SymbolAirportShuttleIcon } from "./icons/SymbolAirportShuttleIcon.tsx";
import { SymbolRvHookupIcon } from "./icons/SymbolRvHookupIcon.tsx";
import { SymbolFireTruckIcon } from "./icons/SymbolFireTruckIcon.tsx";
import { SymbolTwoWheelerIcon } from "./icons/SymbolTwoWheelerIcon.tsx";
import { SymbolMopedIcon } from "./icons/SymbolMopedIcon.tsx";
import { SymbolPedalBikeIcon } from "./icons/SymbolPedalBikeIcon.tsx";
import { SymbolDirectionsBusIcon } from "./icons/SymbolDirectionsBusIcon.tsx";
import { SymbolTrainIcon } from "./icons/SymbolTrainIcon.tsx";
import { SymbolTramIcon } from "./icons/SymbolTramIcon.tsx";
import { SymbolSubwayIcon } from "./icons/SymbolSubwayIcon.tsx";
import { SymbolFlightIcon } from "./icons/SymbolFlightIcon.tsx";
import { SymbolRocketLaunchIcon } from "./icons/SymbolRocketLaunchIcon.tsx";
import { SymbolRocketIcon } from "./icons/SymbolRocketIcon.tsx";
import { SymbolSailingIcon } from "./icons/SymbolSailingIcon.tsx";
import { SymbolDirectionsBoatIcon } from "./icons/SymbolDirectionsBoatIcon.tsx";
import { SymbolAnchorIcon } from "./icons/SymbolAnchorIcon.tsx";
import { SymbolSnowmobileIcon } from "./icons/SymbolSnowmobileIcon.tsx";
import { SymbolExploreIcon } from "./icons/SymbolExploreIcon.tsx";
import { SymbolMapIcon } from "./icons/SymbolMapIcon.tsx";
import { SymbolPlaceIcon } from "./icons/SymbolPlaceIcon.tsx";
import { SymbolNavigationIcon } from "./icons/SymbolNavigationIcon.tsx";
import { SymbolRouteIcon } from "./icons/SymbolRouteIcon.tsx";
import { SymbolSignpostIcon } from "./icons/SymbolSignpostIcon.tsx";
import { SymbolTourIcon } from "./icons/SymbolTourIcon.tsx";
import { SymbolLuggageIcon } from "./icons/SymbolLuggageIcon.tsx";
import { SymbolFlagIcon } from "./icons/SymbolFlagIcon.tsx";
import { SymbolRestaurantIcon } from "./icons/SymbolRestaurantIcon.tsx";
import { SymbolLocalPizzaIcon } from "./icons/SymbolLocalPizzaIcon.tsx";
import { SymbolLunchDiningIcon } from "./icons/SymbolLunchDiningIcon.tsx";
import { SymbolDinnerDiningIcon } from "./icons/SymbolDinnerDiningIcon.tsx";
import { SymbolBrunchDiningIcon } from "./icons/SymbolBrunchDiningIcon.tsx";
import { SymbolBakeryDiningIcon } from "./icons/SymbolBakeryDiningIcon.tsx";
import { SymbolRamenDiningIcon } from "./icons/SymbolRamenDiningIcon.tsx";
import { SymbolKebabDiningIcon } from "./icons/SymbolKebabDiningIcon.tsx";
import { SymbolRiceBowlIcon } from "./icons/SymbolRiceBowlIcon.tsx";
import { SymbolTapasIcon } from "./icons/SymbolTapasIcon.tsx";
import { SymbolFastfoodIcon } from "./icons/SymbolFastfoodIcon.tsx";
import { SymbolIcecreamIcon } from "./icons/SymbolIcecreamIcon.tsx";
import { SymbolCakeIcon } from "./icons/SymbolCakeIcon.tsx";
import { SymbolCookieIcon } from "./icons/SymbolCookieIcon.tsx";
import { SymbolNutritionIcon } from "./icons/SymbolNutritionIcon.tsx";
import { SymbolLocalCafeIcon } from "./icons/SymbolLocalCafeIcon.tsx";
import { SymbolCoffeeIcon } from "./icons/SymbolCoffeeIcon.tsx";
import { SymbolEmojiFoodBeverageIcon } from "./icons/SymbolEmojiFoodBeverageIcon.tsx";
import { SymbolLocalBarIcon } from "./icons/SymbolLocalBarIcon.tsx";
import { SymbolWineBarIcon } from "./icons/SymbolWineBarIcon.tsx";
import { SymbolSportsBarIcon } from "./icons/SymbolSportsBarIcon.tsx";
import { SymbolLiquorIcon } from "./icons/SymbolLiquorIcon.tsx";
import { SymbolGroceryIcon } from "./icons/SymbolGroceryIcon.tsx";
import { SymbolKitchenIcon } from "./icons/SymbolKitchenIcon.tsx";
import { SymbolBlenderIcon } from "./icons/SymbolBlenderIcon.tsx";
import { SymbolOutdoorGrillIcon } from "./icons/SymbolOutdoorGrillIcon.tsx";
import { SymbolSoupKitchenIcon } from "./icons/SymbolSoupKitchenIcon.tsx";
import { SymbolSportsSoccerIcon } from "./icons/SymbolSportsSoccerIcon.tsx";
import { SymbolSportsBasketballIcon } from "./icons/SymbolSportsBasketballIcon.tsx";
import { SymbolSportsFootballIcon } from "./icons/SymbolSportsFootballIcon.tsx";
import { SymbolSportsBaseballIcon } from "./icons/SymbolSportsBaseballIcon.tsx";
import { SymbolSportsTennisIcon } from "./icons/SymbolSportsTennisIcon.tsx";
import { SymbolSportsGolfIcon } from "./icons/SymbolSportsGolfIcon.tsx";
import { SymbolSportsVolleyballIcon } from "./icons/SymbolSportsVolleyballIcon.tsx";
import { SymbolSportsHockeyIcon } from "./icons/SymbolSportsHockeyIcon.tsx";
import { SymbolSportsEsportsIcon } from "./icons/SymbolSportsEsportsIcon.tsx";
import { SymbolSportsMotorsportsIcon } from "./icons/SymbolSportsMotorsportsIcon.tsx";
import { SymbolSportsMartialArtsIcon } from "./icons/SymbolSportsMartialArtsIcon.tsx";
import { SymbolSportsIcon } from "./icons/SymbolSportsIcon.tsx";
import { SymbolFitnessCenterIcon } from "./icons/SymbolFitnessCenterIcon.tsx";
import { SymbolPoolIcon } from "./icons/SymbolPoolIcon.tsx";
import { SymbolSurfingIcon } from "./icons/SymbolSurfingIcon.tsx";
import { SymbolDownhillSkiingIcon } from "./icons/SymbolDownhillSkiingIcon.tsx";
import { SymbolHikingIcon } from "./icons/SymbolHikingIcon.tsx";
import { SymbolSkateboardingIcon } from "./icons/SymbolSkateboardingIcon.tsx";
import { SymbolKayakingIcon } from "./icons/SymbolKayakingIcon.tsx";
import { SymbolSelfImprovementIcon } from "./icons/SymbolSelfImprovementIcon.tsx";
import { SymbolTrophyIcon } from "./icons/SymbolTrophyIcon.tsx";
import { SymbolMilitaryTechIcon } from "./icons/SymbolMilitaryTechIcon.tsx";
import { SymbolWorkspacePremiumIcon } from "./icons/SymbolWorkspacePremiumIcon.tsx";
import { SymbolToysIcon } from "./icons/SymbolToysIcon.tsx";
import { SymbolCasinoIcon } from "./icons/SymbolCasinoIcon.tsx";
import { SymbolExtensionIcon } from "./icons/SymbolExtensionIcon.tsx";
import { SymbolPianoIcon } from "./icons/SymbolPianoIcon.tsx";
import { SymbolMusicNoteIcon } from "./icons/SymbolMusicNoteIcon.tsx";
import { SymbolHeadphonesIcon } from "./icons/SymbolHeadphonesIcon.tsx";
import { SymbolTheatersIcon } from "./icons/SymbolTheatersIcon.tsx";
import { SymbolMovieIcon } from "./icons/SymbolMovieIcon.tsx";
import { SymbolVideogameAssetIcon } from "./icons/SymbolVideogameAssetIcon.tsx";
import { SymbolCelebrationIcon } from "./icons/SymbolCelebrationIcon.tsx";
import { SymbolLightbulbIcon } from "./icons/SymbolLightbulbIcon.tsx";
import { SymbolKeyIcon } from "./icons/SymbolKeyIcon.tsx";
import { SymbolLockIcon } from "./icons/SymbolLockIcon.tsx";
import { SymbolShieldIcon } from "./icons/SymbolShieldIcon.tsx";
import { SymbolUmbrellaIcon } from "./icons/SymbolUmbrellaIcon.tsx";
import { SymbolBackpackIcon } from "./icons/SymbolBackpackIcon.tsx";
import { SymbolWatchIcon } from "./icons/SymbolWatchIcon.tsx";
import { SymbolDiamondIcon } from "./icons/SymbolDiamondIcon.tsx";
import { SymbolCrownIcon } from "./icons/SymbolCrownIcon.tsx";
import { SymbolRedeemIcon } from "./icons/SymbolRedeemIcon.tsx";
import { SymbolShoppingCartIcon } from "./icons/SymbolShoppingCartIcon.tsx";
import { SymbolShoppingBagIcon } from "./icons/SymbolShoppingBagIcon.tsx";
import { SymbolLocalMallIcon } from "./icons/SymbolLocalMallIcon.tsx";
import { SymbolPaymentsIcon } from "./icons/SymbolPaymentsIcon.tsx";
import { SymbolCreditCardIcon } from "./icons/SymbolCreditCardIcon.tsx";
import { SymbolSavingsIcon } from "./icons/SymbolSavingsIcon.tsx";
import { SymbolAccountBalanceWalletIcon } from "./icons/SymbolAccountBalanceWalletIcon.tsx";
import { SymbolAttachMoneyIcon } from "./icons/SymbolAttachMoneyIcon.tsx";
import { SymbolPaidIcon } from "./icons/SymbolPaidIcon.tsx";
import { SymbolSellIcon } from "./icons/SymbolSellIcon.tsx";
import { SymbolReceiptLongIcon } from "./icons/SymbolReceiptLongIcon.tsx";
import { SymbolWorkIcon } from "./icons/SymbolWorkIcon.tsx";
import { SymbolBusinessCenterIcon } from "./icons/SymbolBusinessCenterIcon.tsx";
import { SymbolInventory2Icon } from "./icons/SymbolInventory2Icon.tsx";
import { SymbolPackage2Icon } from "./icons/SymbolPackage2Icon.tsx";
import { SymbolDeployedCodeIcon } from "./icons/SymbolDeployedCodeIcon.tsx";
import { SymbolPaletteIcon } from "./icons/SymbolPaletteIcon.tsx";
import { SymbolBrushIcon } from "./icons/SymbolBrushIcon.tsx";
import { SymbolDrawIcon } from "./icons/SymbolDrawIcon.tsx";
import { SymbolPhotoCameraIcon } from "./icons/SymbolPhotoCameraIcon.tsx";
import { SymbolVideocamIcon } from "./icons/SymbolVideocamIcon.tsx";
import { SymbolMicIcon } from "./icons/SymbolMicIcon.tsx";
import { SymbolSmartphoneIcon } from "./icons/SymbolSmartphoneIcon.tsx";
import { SymbolComputerIcon } from "./icons/SymbolComputerIcon.tsx";
import { SymbolKeyboardIcon } from "./icons/SymbolKeyboardIcon.tsx";
import { SymbolMemoryIcon } from "./icons/SymbolMemoryIcon.tsx";
import { SymbolSmartToyIcon } from "./icons/SymbolSmartToyIcon.tsx";
import { SymbolScienceIcon } from "./icons/SymbolScienceIcon.tsx";
import { SymbolBiotechIcon } from "./icons/SymbolBiotechIcon.tsx";
import { SymbolExperimentIcon } from "./icons/SymbolExperimentIcon.tsx";
import { SymbolPsychologyIcon } from "./icons/SymbolPsychologyIcon.tsx";
import { SymbolMenuBookIcon } from "./icons/SymbolMenuBookIcon.tsx";
import { SymbolAutoStoriesIcon } from "./icons/SymbolAutoStoriesIcon.tsx";
import { SymbolBookIcon } from "./icons/SymbolBookIcon.tsx";
import { SymbolTimerIcon } from "./icons/SymbolTimerIcon.tsx";
import { SymbolAlarmIcon } from "./icons/SymbolAlarmIcon.tsx";
import { SymbolHourglassTopIcon } from "./icons/SymbolHourglassTopIcon.tsx";
import { SymbolCalendarMonthIcon } from "./icons/SymbolCalendarMonthIcon.tsx";
import { SymbolScheduleIcon } from "./icons/SymbolScheduleIcon.tsx";
import { SymbolCampaignIcon } from "./icons/SymbolCampaignIcon.tsx";
import { SymbolHandshakeIcon } from "./icons/SymbolHandshakeIcon.tsx";
import { SymbolVolunteerActivismIcon } from "./icons/SymbolVolunteerActivismIcon.tsx";
import { SymbolSupportAgentIcon } from "./icons/SymbolSupportAgentIcon.tsx";
import { SymbolGroupsIcon } from "./icons/SymbolGroupsIcon.tsx";
import { SymbolGroupIcon } from "./icons/SymbolGroupIcon.tsx";
import { SymbolPersonIcon } from "./icons/SymbolPersonIcon.tsx";
import { SymbolDiversity3Icon } from "./icons/SymbolDiversity3Icon.tsx";
import { SymbolMoodIcon } from "./icons/SymbolMoodIcon.tsx";
import { SymbolFaceIcon } from "./icons/SymbolFaceIcon.tsx";
import { SymbolAccessibilityNewIcon } from "./icons/SymbolAccessibilityNewIcon.tsx";
import { SymbolMedicalServicesIcon } from "./icons/SymbolMedicalServicesIcon.tsx";
import { SymbolHealthAndSafetyIcon } from "./icons/SymbolHealthAndSafetyIcon.tsx";
import { SymbolMedicationIcon } from "./icons/SymbolMedicationIcon.tsx";
import { SymbolEcgHeartIcon } from "./icons/SymbolEcgHeartIcon.tsx";
import { SymbolSpaIcon } from "./icons/SymbolSpaIcon.tsx";
import { SymbolMagicButtonIcon } from "./icons/SymbolMagicButtonIcon.tsx";
import { SymbolAutoAwesomeIcon } from "./icons/SymbolAutoAwesomeIcon.tsx";
import { SymbolCircleIcon } from "./icons/SymbolCircleIcon.tsx";
import { SymbolSquareIcon } from "./icons/SymbolSquareIcon.tsx";
import { SymbolChangeHistoryIcon } from "./icons/SymbolChangeHistoryIcon.tsx";
import { SymbolPentagonIcon } from "./icons/SymbolPentagonIcon.tsx";
import { SymbolHexagonIcon } from "./icons/SymbolHexagonIcon.tsx";
import { SymbolStarIcon } from "./icons/SymbolStarIcon.tsx";
import { SymbolFavoriteIcon } from "./icons/SymbolFavoriteIcon.tsx";
import { SymbolBoltIcon } from "./icons/SymbolBoltIcon.tsx";
import { SymbolFlashOnIcon } from "./icons/SymbolFlashOnIcon.tsx";
import { SymbolHiveIcon } from "./icons/SymbolHiveIcon.tsx";
import { SymbolInterestsIcon } from "./icons/SymbolInterestsIcon.tsx";
import { SymbolCategoryIcon } from "./icons/SymbolCategoryIcon.tsx";
import { SymbolTokenIcon } from "./icons/SymbolTokenIcon.tsx";
import { SymbolLabelIcon } from "./icons/SymbolLabelIcon.tsx";
import { SymbolBookmarkIcon } from "./icons/SymbolBookmarkIcon.tsx";
import { SymbolAllInclusiveIcon } from "./icons/SymbolAllInclusiveIcon.tsx";
import { SymbolLoyaltyIcon } from "./icons/SymbolLoyaltyIcon.tsx";
import { SymbolVerifiedIcon } from "./icons/SymbolVerifiedIcon.tsx";
import { SymbolRecommendIcon } from "./icons/SymbolRecommendIcon.tsx";
import { SymbolThumbUpIcon } from "./icons/SymbolThumbUpIcon.tsx";
import { SymbolTargetIcon } from "./icons/SymbolTargetIcon.tsx";
import { SymbolAdsClickIcon } from "./icons/SymbolAdsClickIcon.tsx";
import { SymbolAdjustIcon } from "./icons/SymbolAdjustIcon.tsx";
import { SymbolAccountTreeIcon } from "./icons/SymbolAccountTreeIcon.tsx";
import { SymbolSchemaIcon } from "./icons/SymbolSchemaIcon.tsx";
import { SymbolLanIcon } from "./icons/SymbolLanIcon.tsx";
import { SymbolHubIcon } from "./icons/SymbolHubIcon.tsx";
import { SymbolBlurOnIcon } from "./icons/SymbolBlurOnIcon.tsx";
import { SymbolGestureIcon } from "./icons/SymbolGestureIcon.tsx";

export const pickerIcons = {
  "symbol-roofing": SymbolRoofingIcon,
  "symbol-construction": SymbolConstructionIcon,
  "symbol-handyman": SymbolHandymanIcon,
  "symbol-hardware": SymbolHardwareIcon,
  "symbol-build": SymbolBuildIcon,
  "symbol-home-repair-service": SymbolHomeRepairServiceIcon,
  "symbol-plumbing": SymbolPlumbingIcon,
  "symbol-carpenter": SymbolCarpenterIcon,
  "symbol-electrical-services": SymbolElectricalServicesIcon,
  "symbol-architecture": SymbolArchitectureIcon,
  "symbol-engineering": SymbolEngineeringIcon,
  "symbol-foundation": SymbolFoundationIcon,
  "symbol-fence": SymbolFenceIcon,
  "symbol-deck": SymbolDeckIcon,
  "symbol-format-paint": SymbolFormatPaintIcon,
  "symbol-imagesearch-roller": SymbolImagesearchRollerIcon,
  "symbol-design-services": SymbolDesignServicesIcon,
  "symbol-straighten": SymbolStraightenIcon,
  "symbol-square-foot": SymbolSquareFootIcon,
  "symbol-hvac": SymbolHvacIcon,
  "symbol-solar-power": SymbolSolarPowerIcon,
  "symbol-water-damage": SymbolWaterDamageIcon,
  "symbol-pest-control": SymbolPestControlIcon,
  "symbol-cleaning-services": SymbolCleaningServicesIcon,
  "symbol-precision-manufacturing": SymbolPrecisionManufacturingIcon,
  "symbol-tools-power-drill": SymbolToolsPowerDrillIcon,
  "symbol-tools-ladder": SymbolToolsLadderIcon,
  "symbol-tools-level": SymbolToolsLevelIcon,
  "symbol-tools-pliers-wire-stripper": SymbolToolsPliersWireStripperIcon,
  "symbol-tools-flat-head": SymbolToolsFlatHeadIcon,
  "symbol-agriculture": SymbolAgricultureIcon,
  "symbol-forklift": SymbolForkliftIcon,
  "symbol-front-loader": SymbolFrontLoaderIcon,
  "symbol-fire-extinguisher": SymbolFireExtinguisherIcon,
  "symbol-home": SymbolHomeIcon,
  "symbol-cottage": SymbolCottageIcon,
  "symbol-villa": SymbolVillaIcon,
  "symbol-house": SymbolHouseIcon,
  "symbol-cabin": SymbolCabinIcon,
  "symbol-chalet": SymbolChaletIcon,
  "symbol-bungalow": SymbolBungalowIcon,
  "symbol-gite": SymbolGiteIcon,
  "symbol-other-houses": SymbolOtherHousesIcon,
  "symbol-holiday-village": SymbolHolidayVillageIcon,
  "symbol-apartment": SymbolApartmentIcon,
  "symbol-domain": SymbolDomainIcon,
  "symbol-corporate-fare": SymbolCorporateFareIcon,
  "symbol-location-city": SymbolLocationCityIcon,
  "symbol-warehouse": SymbolWarehouseIcon,
  "symbol-garage": SymbolGarageIcon,
  "symbol-garage-home": SymbolGarageHomeIcon,
  "symbol-factory": SymbolFactoryIcon,
  "symbol-store": SymbolStoreIcon,
  "symbol-storefront": SymbolStorefrontIcon,
  "symbol-castle": SymbolCastleIcon,
  "symbol-church": SymbolChurchIcon,
  "symbol-school": SymbolSchoolIcon,
  "symbol-stadium": SymbolStadiumIcon,
  "symbol-account-balance": SymbolAccountBalanceIcon,
  "symbol-hotel": SymbolHotelIcon,
  "symbol-real-estate-agent": SymbolRealEstateAgentIcon,
  "symbol-home-work": SymbolHomeWorkIcon,
  "symbol-yard": SymbolYardIcon,
  "symbol-local-hospital": SymbolLocalHospitalIcon,
  "symbol-museum": SymbolMuseumIcon,
  "symbol-festival": SymbolFestivalIcon,
  "symbol-park": SymbolParkIcon,
  "symbol-forest": SymbolForestIcon,
  "symbol-nature": SymbolNatureIcon,
  "symbol-eco": SymbolEcoIcon,
  "symbol-grass": SymbolGrassIcon,
  "symbol-potted-plant": SymbolPottedPlantIcon,
  "symbol-local-florist": SymbolLocalFloristIcon,
  "symbol-landscape": SymbolLandscapeIcon,
  "symbol-volcano": SymbolVolcanoIcon,
  "symbol-water-drop": SymbolWaterDropIcon,
  "symbol-water": SymbolWaterIcon,
  "symbol-waves": SymbolWavesIcon,
  "symbol-tsunami": SymbolTsunamiIcon,
  "symbol-flood": SymbolFloodIcon,
  "symbol-sunny": SymbolSunnyIcon,
  "symbol-partly-cloudy-day": SymbolPartlyCloudyDayIcon,
  "symbol-cloud": SymbolCloudIcon,
  "symbol-rainy": SymbolRainyIcon,
  "symbol-thunderstorm": SymbolThunderstormIcon,
  "symbol-storm": SymbolStormIcon,
  "symbol-tornado": SymbolTornadoIcon,
  "symbol-foggy": SymbolFoggyIcon,
  "symbol-air": SymbolAirIcon,
  "symbol-ac-unit": SymbolAcUnitIcon,
  "symbol-severe-cold": SymbolSevereColdIcon,
  "symbol-sunny-snowing": SymbolSunnySnowingIcon,
  "symbol-bedtime": SymbolBedtimeIcon,
  "symbol-nightlight": SymbolNightlightIcon,
  "symbol-wb-twilight": SymbolWbTwilightIcon,
  "symbol-local-fire-department": SymbolLocalFireDepartmentIcon,
  "symbol-whatshot": SymbolWhatshotIcon,
  "symbol-public": SymbolPublicIcon,
  "symbol-compost": SymbolCompostIcon,
  "symbol-energy-savings-leaf": SymbolEnergySavingsLeafIcon,
  "symbol-pets": SymbolPetsIcon,
  "symbol-cruelty-free": SymbolCrueltyFreeIcon,
  "symbol-raven": SymbolRavenIcon,
  "symbol-emoji-nature": SymbolEmojiNatureIcon,
  "symbol-bug-report": SymbolBugReportIcon,
  "symbol-sound-detection-dog-barking": SymbolSoundDetectionDogBarkingIcon,
  "symbol-set-meal": SymbolSetMealIcon,
  "symbol-egg": SymbolEggIcon,
  "symbol-phishing": SymbolPhishingIcon,
  "symbol-directions-car": SymbolDirectionsCarIcon,
  "symbol-electric-car": SymbolElectricCarIcon,
  "symbol-local-shipping": SymbolLocalShippingIcon,
  "symbol-local-taxi": SymbolLocalTaxiIcon,
  "symbol-airport-shuttle": SymbolAirportShuttleIcon,
  "symbol-rv-hookup": SymbolRvHookupIcon,
  "symbol-fire-truck": SymbolFireTruckIcon,
  "symbol-two-wheeler": SymbolTwoWheelerIcon,
  "symbol-moped": SymbolMopedIcon,
  "symbol-pedal-bike": SymbolPedalBikeIcon,
  "symbol-directions-bus": SymbolDirectionsBusIcon,
  "symbol-train": SymbolTrainIcon,
  "symbol-tram": SymbolTramIcon,
  "symbol-subway": SymbolSubwayIcon,
  "symbol-flight": SymbolFlightIcon,
  "symbol-rocket-launch": SymbolRocketLaunchIcon,
  "symbol-rocket": SymbolRocketIcon,
  "symbol-sailing": SymbolSailingIcon,
  "symbol-directions-boat": SymbolDirectionsBoatIcon,
  "symbol-anchor": SymbolAnchorIcon,
  "symbol-snowmobile": SymbolSnowmobileIcon,
  "symbol-explore": SymbolExploreIcon,
  "symbol-map": SymbolMapIcon,
  "symbol-place": SymbolPlaceIcon,
  "symbol-navigation": SymbolNavigationIcon,
  "symbol-route": SymbolRouteIcon,
  "symbol-signpost": SymbolSignpostIcon,
  "symbol-tour": SymbolTourIcon,
  "symbol-luggage": SymbolLuggageIcon,
  "symbol-flag": SymbolFlagIcon,
  "symbol-restaurant": SymbolRestaurantIcon,
  "symbol-local-pizza": SymbolLocalPizzaIcon,
  "symbol-lunch-dining": SymbolLunchDiningIcon,
  "symbol-dinner-dining": SymbolDinnerDiningIcon,
  "symbol-brunch-dining": SymbolBrunchDiningIcon,
  "symbol-bakery-dining": SymbolBakeryDiningIcon,
  "symbol-ramen-dining": SymbolRamenDiningIcon,
  "symbol-kebab-dining": SymbolKebabDiningIcon,
  "symbol-rice-bowl": SymbolRiceBowlIcon,
  "symbol-tapas": SymbolTapasIcon,
  "symbol-fastfood": SymbolFastfoodIcon,
  "symbol-icecream": SymbolIcecreamIcon,
  "symbol-cake": SymbolCakeIcon,
  "symbol-cookie": SymbolCookieIcon,
  "symbol-nutrition": SymbolNutritionIcon,
  "symbol-local-cafe": SymbolLocalCafeIcon,
  "symbol-coffee": SymbolCoffeeIcon,
  "symbol-emoji-food-beverage": SymbolEmojiFoodBeverageIcon,
  "symbol-local-bar": SymbolLocalBarIcon,
  "symbol-wine-bar": SymbolWineBarIcon,
  "symbol-sports-bar": SymbolSportsBarIcon,
  "symbol-liquor": SymbolLiquorIcon,
  "symbol-grocery": SymbolGroceryIcon,
  "symbol-kitchen": SymbolKitchenIcon,
  "symbol-blender": SymbolBlenderIcon,
  "symbol-outdoor-grill": SymbolOutdoorGrillIcon,
  "symbol-soup-kitchen": SymbolSoupKitchenIcon,
  "symbol-sports-soccer": SymbolSportsSoccerIcon,
  "symbol-sports-basketball": SymbolSportsBasketballIcon,
  "symbol-sports-football": SymbolSportsFootballIcon,
  "symbol-sports-baseball": SymbolSportsBaseballIcon,
  "symbol-sports-tennis": SymbolSportsTennisIcon,
  "symbol-sports-golf": SymbolSportsGolfIcon,
  "symbol-sports-volleyball": SymbolSportsVolleyballIcon,
  "symbol-sports-hockey": SymbolSportsHockeyIcon,
  "symbol-sports-esports": SymbolSportsEsportsIcon,
  "symbol-sports-motorsports": SymbolSportsMotorsportsIcon,
  "symbol-sports-martial-arts": SymbolSportsMartialArtsIcon,
  "symbol-sports": SymbolSportsIcon,
  "symbol-fitness-center": SymbolFitnessCenterIcon,
  "symbol-pool": SymbolPoolIcon,
  "symbol-surfing": SymbolSurfingIcon,
  "symbol-downhill-skiing": SymbolDownhillSkiingIcon,
  "symbol-hiking": SymbolHikingIcon,
  "symbol-skateboarding": SymbolSkateboardingIcon,
  "symbol-kayaking": SymbolKayakingIcon,
  "symbol-self-improvement": SymbolSelfImprovementIcon,
  "symbol-trophy": SymbolTrophyIcon,
  "symbol-military-tech": SymbolMilitaryTechIcon,
  "symbol-workspace-premium": SymbolWorkspacePremiumIcon,
  "symbol-toys": SymbolToysIcon,
  "symbol-casino": SymbolCasinoIcon,
  "symbol-extension": SymbolExtensionIcon,
  "symbol-piano": SymbolPianoIcon,
  "symbol-music-note": SymbolMusicNoteIcon,
  "symbol-headphones": SymbolHeadphonesIcon,
  "symbol-theaters": SymbolTheatersIcon,
  "symbol-movie": SymbolMovieIcon,
  "symbol-videogame-asset": SymbolVideogameAssetIcon,
  "symbol-celebration": SymbolCelebrationIcon,
  "symbol-lightbulb": SymbolLightbulbIcon,
  "symbol-key": SymbolKeyIcon,
  "symbol-lock": SymbolLockIcon,
  "symbol-shield": SymbolShieldIcon,
  "symbol-umbrella": SymbolUmbrellaIcon,
  "symbol-backpack": SymbolBackpackIcon,
  "symbol-watch": SymbolWatchIcon,
  "symbol-diamond": SymbolDiamondIcon,
  "symbol-crown": SymbolCrownIcon,
  "symbol-redeem": SymbolRedeemIcon,
  "symbol-shopping-cart": SymbolShoppingCartIcon,
  "symbol-shopping-bag": SymbolShoppingBagIcon,
  "symbol-local-mall": SymbolLocalMallIcon,
  "symbol-payments": SymbolPaymentsIcon,
  "symbol-credit-card": SymbolCreditCardIcon,
  "symbol-savings": SymbolSavingsIcon,
  "symbol-account-balance-wallet": SymbolAccountBalanceWalletIcon,
  "symbol-attach-money": SymbolAttachMoneyIcon,
  "symbol-paid": SymbolPaidIcon,
  "symbol-sell": SymbolSellIcon,
  "symbol-receipt-long": SymbolReceiptLongIcon,
  "symbol-work": SymbolWorkIcon,
  "symbol-business-center": SymbolBusinessCenterIcon,
  "symbol-inventory-2": SymbolInventory2Icon,
  "symbol-package-2": SymbolPackage2Icon,
  "symbol-deployed-code": SymbolDeployedCodeIcon,
  "symbol-palette": SymbolPaletteIcon,
  "symbol-brush": SymbolBrushIcon,
  "symbol-draw": SymbolDrawIcon,
  "symbol-photo-camera": SymbolPhotoCameraIcon,
  "symbol-videocam": SymbolVideocamIcon,
  "symbol-mic": SymbolMicIcon,
  "symbol-smartphone": SymbolSmartphoneIcon,
  "symbol-computer": SymbolComputerIcon,
  "symbol-keyboard": SymbolKeyboardIcon,
  "symbol-memory": SymbolMemoryIcon,
  "symbol-smart-toy": SymbolSmartToyIcon,
  "symbol-science": SymbolScienceIcon,
  "symbol-biotech": SymbolBiotechIcon,
  "symbol-experiment": SymbolExperimentIcon,
  "symbol-psychology": SymbolPsychologyIcon,
  "symbol-menu-book": SymbolMenuBookIcon,
  "symbol-auto-stories": SymbolAutoStoriesIcon,
  "symbol-book": SymbolBookIcon,
  "symbol-timer": SymbolTimerIcon,
  "symbol-alarm": SymbolAlarmIcon,
  "symbol-hourglass-top": SymbolHourglassTopIcon,
  "symbol-calendar-month": SymbolCalendarMonthIcon,
  "symbol-schedule": SymbolScheduleIcon,
  "symbol-campaign": SymbolCampaignIcon,
  "symbol-handshake": SymbolHandshakeIcon,
  "symbol-volunteer-activism": SymbolVolunteerActivismIcon,
  "symbol-support-agent": SymbolSupportAgentIcon,
  "symbol-groups": SymbolGroupsIcon,
  "symbol-group": SymbolGroupIcon,
  "symbol-person": SymbolPersonIcon,
  "symbol-diversity-3": SymbolDiversity3Icon,
  "symbol-mood": SymbolMoodIcon,
  "symbol-face": SymbolFaceIcon,
  "symbol-accessibility-new": SymbolAccessibilityNewIcon,
  "symbol-medical-services": SymbolMedicalServicesIcon,
  "symbol-health-and-safety": SymbolHealthAndSafetyIcon,
  "symbol-medication": SymbolMedicationIcon,
  "symbol-ecg-heart": SymbolEcgHeartIcon,
  "symbol-spa": SymbolSpaIcon,
  "symbol-magic-button": SymbolMagicButtonIcon,
  "symbol-auto-awesome": SymbolAutoAwesomeIcon,
  "symbol-circle": SymbolCircleIcon,
  "symbol-square": SymbolSquareIcon,
  "symbol-change-history": SymbolChangeHistoryIcon,
  "symbol-pentagon": SymbolPentagonIcon,
  "symbol-hexagon": SymbolHexagonIcon,
  "symbol-star": SymbolStarIcon,
  "symbol-favorite": SymbolFavoriteIcon,
  "symbol-bolt": SymbolBoltIcon,
  "symbol-flash-on": SymbolFlashOnIcon,
  "symbol-hive": SymbolHiveIcon,
  "symbol-interests": SymbolInterestsIcon,
  "symbol-category": SymbolCategoryIcon,
  "symbol-token": SymbolTokenIcon,
  "symbol-label": SymbolLabelIcon,
  "symbol-bookmark": SymbolBookmarkIcon,
  "symbol-all-inclusive": SymbolAllInclusiveIcon,
  "symbol-loyalty": SymbolLoyaltyIcon,
  "symbol-verified": SymbolVerifiedIcon,
  "symbol-recommend": SymbolRecommendIcon,
  "symbol-thumb-up": SymbolThumbUpIcon,
  "symbol-target": SymbolTargetIcon,
  "symbol-ads-click": SymbolAdsClickIcon,
  "symbol-adjust": SymbolAdjustIcon,
  "symbol-account-tree": SymbolAccountTreeIcon,
  "symbol-schema": SymbolSchemaIcon,
  "symbol-lan": SymbolLanIcon,
  "symbol-hub": SymbolHubIcon,
  "symbol-blur-on": SymbolBlurOnIcon,
  "symbol-gesture": SymbolGestureIcon,
};

export { pickerIconGroups } from "./groups.ts";
export { pickerIconNames } from "./names.ts";
export type { PickerIconProps } from "./types.ts";
